//hier geen jquery gebruiken

idd_addEvent(window, 'load', service_browserFeatures)
idd_addEvent(window, 'load', service_takeScreenshotBox)
idd_addEvent(window, 'load', service_openCloseBox)
idd_addEvent(window, 'load', service_fileInputName)
idd_addEvent(window, 'load', service_autoSubject)

//we willen dat de gebruiker alleen de service ziet als de service in een iframe ziet
//dus dit kijkt of de gebruiker in een in een iframe zit zo niet word die geredirect
if (window.self === window.top) {
	var sp = new URLSearchParams(document.location.search);
	if (sp.has('service') && sp.get('service')=='1') {
		sp.delete('service');
		window.location.replace(window.location.origin + window.location.pathname + '?' + sp.toString());
	}
}


function service_browserFeatures() {
	//undefined als geen form
	if (document.getElementById('iddService_box') === null) return;
	if (document.getElementById('iddService_box').getElementsByTagName('form').length == 0) return;
	
	//screen size
	var rs = screen.width + ' x '+ screen.height;  
	document.getElementById('screensize').setAttribute('value',rs);
	
	//window size
	var rs = window.innerWidth + ' x '+ window.innerHeight;  
	document.getElementById('windowInner').setAttribute('value',rs);
	
	//window size
	var rs = window.outerWidth + ' x '+ window.outerHeight;  
	document.getElementById('windowOuter').setAttribute('value',rs);
	
	//zoom? https://stackoverflow.com/questions/2242086/how-to-detect-the-screen-resolution-with-javascript
	var rs = window.screen.availWidth + ' x ' + window.screen.availHeight;
	document.getElementById('windowAvail').setAttribute('value',rs);
	
	var rs = window.devicePixelRatio;
	document.getElementById('devicePixel').setAttribute('value',rs);
	
	var rs = window.fullScreen?'yes':'no';
	document.getElementById('fullScreen').setAttribute('value',rs);

	
	//je kan ook heel window serializen maar dat is wel erg veel, naief json.stringify gaat niet want cyclisch

	//devices
	var bdevices = [];
	if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
		navigator.mediaDevices.enumerateDevices()
		.then(function(devices) {
			devices.forEach(function(device) {
				bdevices.push({'kind': device.kind, 'label': device.label,'id': device.deviceId})
			});
			document.getElementById('devices').setAttribute('value', JSON_stringify(bdevices));
		})
		.catch(function(err) {
//			console.log(err.name + ": " + err.message);
		});
	} else {
		bdevices.push('Not supported');
		document.getElementById('devices').setAttribute('value', JSON_stringify(bdevices));
	}
	
	//de rest van navigator
	var _navigator = {};
	for (var i in navigator) _navigator[i] = navigator[i];
	document.getElementById('navigator').setAttribute('value', JSON_stringify(_navigator));
	
}


/**
 * Zorgt dat het screenshot vinkje getoont wordt en dat als je er op klikt de screenshot wordt gemaakt.
 */
function service_takeScreenshotBox() {
	const serviceBox = document.getElementById('iddService_box');
	
	//undefined als geen form
	if (serviceBox === null) return;
	if (serviceBox.getElementsByTagName('form').length == 0) return;
	
	// Op telefoon en tablet de optie niet tonen.
	if ('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch ||
	    navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0) return;
	
	var box = document.createElement('span');
	box.className = 'material-icons';
	box.appendChild(document.createTextNode('check')); //Checkmark
	
	// tekst niet te lang want kleine schermen
	var label = document.createElement('label');
	label.className = 'service_label';
	label.appendChild(document.createTextNode(serviceBox.dataset.addScreenshotLabel));
	
	var permissionLabel = document.createElement('i');
	permissionLabel.appendChild(document.createTextNode(serviceBox.dataset.askBrowserPermissionLabel));
	
	//hang label+box in document en met em tekst er naast.
	var screenshot = document.getElementById('iddService_takeScreenshot');
	screenshot.appendChild(box);
	screenshot.appendChild(label);
	screenshot.appendChild(permissionLabel);
	
	screenshot.addEventListener('click', function(e) { service_clickListener(box,label)}, false);
	
}


async function service_clickListener(box,label) {
	//add tick
	if (getComputedStyle(box) != 'coral') {
		box.style.backgroundColor = 'coral';
		box.style.borderColor     = 'coral';
		label.style.color         = 'coral';
	}
	// De iframe waar de servicelink in staat zodat die gebruikt kan worden om de iframe
	// weg te halen tijdens de screenshot.
	const serviceIframe = parent.document.getElementById('serviceIframe');
	serviceIframe.style.transform = 'scale(0)'; // Zorg dat de servicelink op de foto weg is.
	// Het kan zijn dat de gebruiker het blokeert en dan moet de screenshot functie niet gebruikt worden.
	try {
		let screenshot = await _service_takeScreenshot(); // Krijg de base64 terug van de foto om in de hidden input te stoppen.
		// De hidden input voor de base64
		var screenshotFile = document.getElementById('screenshotFile');
		// Hier wordt de screenshot in de hidden file gestopt om het in php een jpg te maken
		screenshotFile.value = screenshot;
	} catch (err) {
		// Zorg dat de checkbox geen styling meer heeft anders lijkt het als of het toch aangevinkt is.
		box.style.backgroundColor = '';
		box.style.borderColor     = '';
		label.style.color         = '';
	}
	
	serviceIframe.style.transform = 'scale(1)'; // Zet de servicelink terug naar de normale grootte.
}


/**
 * Activeer bij veranderingen aan de input file.
**/
function service_fileInputName() {
	var serviceInput = document.querySelector("#attachmentArea input[type=file]");
	if (serviceInput === null) return;
	serviceInput.addEventListener("change", function(e) {
		// Om het aantal files te tonen in de attachmentbox.
		var amountText = this.files.length + " files attached";
		//strip c:\fakepath van filename
		var filename = this.value.split('\\').pop();
		
		// Selecteer de span met tekst en verander het naar de nieuwe filenaam.
		// Toon dan of hoeveel files er zijn geupload of de naam van de enige geuploadde file.
		this.nextElementSibling.innerText = this.files.length > 1 ? amountText : filename;
		
		//max size checken
		var totalSize = 0;
		var fileList = [...serviceInput.files];
		for (var i in fileList) {
			totalSize += fileList[i].size;
		}
		
		if (totalSize > serviceInput.dataset.maxFileSize) {
			var MBs = Math.floor(serviceInput.dataset.maxFileSize/1024/1024);
			serviceInput.setCustomValidity("Attachments too large, max " + MBs + "MB.");
		} else {
			serviceInput.setCustomValidity('');
		}
		serviceInput.reportValidity();
	});
}

function service_autoSubject() {
	if (document.getElementById('iddService_box') === null) return;
	if (document.getElementById('iddService_box').getElementsByTagName('form').length == 0) return;
	
	const message = document.getElementById('message');
	const subject = document.getElementById('subject');
	
	var messageToSubject = function() {
		var stopwoord = ["aan","af","al","alle","alleen","alles","als","alsmede","ander","andere","anders",
		  "ben","bij","bijna","bijv","bijvoorbeeld","binnen","boven","bovendien","bv","daar","daaraan","daarbij",
		  "daarbuiten","daardoor","daarin","daarna","daarnaast","daarom","daaronder","daarop","daarover","daartoe",
		  "daaruit","daarvan","daarvoor","dan","dat","de","der","deze","die","dit","door","doordat","dus","dwz",
		  "echter","een","eens","eerst","en","enz","er","ermee","erg","ergens","ervan","ervaring","ervoor","etc",
		  "even","evenals","eveneens","ge","gehad","geweest","geworden","had","hadden","heb","hebben","hebt","heden",
		  "heeft","hem","hen","het","hier","hieraan","hierbij","hierdoor","hierin","hiermee","hierna","hieronder",
		  "hierop","hiertoe","hieruit","hiervan","hiervoor","hij","hoe","hoewel","hun","ik","in","indien","is","ja",
		  "je","jij","jullie","kan","kon","konden","kunt","kunnen","maar","maw","me","mee","men","met","middels","mijn",
		  "misschien","mits","na","naar","naast","nadat","nee","net","niets","nl","nog","nogal","nou","nu","of","om",
		  "omdat","ondermeer","ons","onze","ook","op","over","overig","overige","overigens","reeds","sinds","slechts",
		  "soms","tbv","te","tegen","ten","tenzij","ter","terug","terwijl","tevens","tijdens","toch","toe","toen","tot",
		  "totdat","tussen","uit","uw","vaak","van","vanaf","vandaar","vanuit","vanwege","vervolgens","volgens","voor",
		  "vooraf","vooral","voordat","voorheen","voornamelijk","waar","waaraan","waarbij","waardoor","waarin",
		  "waarmee","waarna","waarom","waarop","waaronder","waaruit","waarvan","waarvoor","wanneer","want","waren",
		  "was","wat","we","weer","wel","welk","welke","wellicht","werd","werden","wie","wij","worden","wordt","zal",
		  "ze","zeer","zelf","zelfs","zich","zij","zijn","zo","zoals","zodat","zowel","zou","zouden","zult",
		  "zullen","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y",
		  "z",'hi','beste','hoeft','meteen','steeds','we','jezelf', 'moet',
		  //engels
		  "able","about","above","according","accordingly","across","actually","additionally","after","again","against",
		  "ago","all","almost","along","already","also","although","always","am","among","amongst","an","and","another",
		  "any","anyhow","anyone","anything","anyway","anywhere","apart","approximately","are","aren","arent","around",
		  "as","aside","at","away","back","badly","basically","be","became","because","become","becoming","been",
		  "before","beforehand","behind","being","below","beside","best","better","between","beyond","both","but","by",
		  "can","cannot","cant","certainly","clearly","closely","completely","could","couldn","couldnt","currently",
		  "despite","did","didn","didnt","different","differently","directly","do","does","doesn","doing","don","done",
		  "dont","down","due","during","each","earlier","earliest","early","easily","effectively","eg","either","else",
		  "enough","entire","entirely","equally","especially","etc","even","eventually","ever","every","everyone",
		  "everything","everywhere","exactly","except","extremely","few","finally","firstly","for","former","formerly",
		  "frequently","from","fully","further","furthermore","generally","get","go","goes","going","got","gotten",
		  "had","hardly","has","have","haven","havent","having","he","hence","her","here","hereby","herein","hers",
		  "herself","high","highly","him","himself","his","how","however","if","immediately","in","including","indeed",
		  "initially","inside","instead","into","is","isn","isnt","it","its","itself","just","justly","largely","last",
		  "lastly","late","lately","lately","later","later","latest","latest","latter","latterly","least","less",
		  "let","like","likely","little","long","lot","low","mainly","many","may","maybe","me","meanwhile","might",
		  "more","moreover","most","mostly","much","my","myself","namely","near","nearly","neither","never",
		  "nevertheless","no","non","none","nonetheless","nor","not","nothing","notwithstanding","now","nowhere","of",
		  "often","ok","on","once","only","onto","or","other","otherwise","our","ours","ourselves","out","over",
		  "overall","own","particularly","past","per","perhaps","present","presently","previously","primarily",
		  "probably","properly","provided","put","quite","rarely","rather","re","really","recently","regardless",
		  "regularly","respectively","rightly","same","self","several","shall","she","shortly","should","similar",
		  "similarly","since","sincere","sincerely","so","sole","solely","some","somehow","someone","something",
		  "sometime","somewhat","somewhere","still","subsequently","such","th","than","that","the","their","them",
		  "themselves","then","there","thereafter","thereby","therefore","therein","thereof","these","they","this",
		  "thorough","thoroughly","those","though","through","throughout","thru","thus","till","to","together","too",
		  "toward","towards","unable","under","unless","unlike","until","up","upon","us","usual","usually","very",
		  "via","was","wasn","wasnt","we","went","were","weren","werent","what","whatever","when","whence","whenever",
		  "where","whereas","whereby","wherein","whereupon","wherever","whether","which","while","whilst","who",
		  "whoever","whole","wholly","whom","whomever","whose","why","widely","will","with","within","without","would",
		  "wouldn","wouldnt","yes","yet","you","your","yours","yourself","yourselves",];
		
		var messageText = this.value.toLowerCase();
		
		//mensen schrijven ... of ???
		messageText = messageText.replaceAll('..','.');
		messageText = messageText.replaceAll('..','.');
		messageText = messageText.replaceAll('..','.');
		messageText = messageText.replaceAll('..','.');
		messageText = messageText.replaceAll('??','?');
		messageText = messageText.replaceAll('??','?');
		messageText = messageText.replaceAll('??','?');
		messageText = messageText.replaceAll('!!','!');
		messageText = messageText.replaceAll('!!','!');
		
		const zinEinde = /[.?!]/g;
		
		//zoek eerste twee zinnen (eindigen met !/?/.
		var matches = messageText.matchAll(zinEinde);
		
		var pos = messageText.length;
		var i = 1;
		for (const match of matches) {
			pos = match.index;
			if (++i > 2) break;
		}
		
		messageText = messageText.slice(0,pos+1);
		
		//stukje voor eerste komma (groet) mag weg
		comma = messageText.match(/,/);
		if (comma !== null) {
			if (comma.index < 20) messageText = messageText.slice(comma.index+1);
		}
		
		//wat rare dingen eruit filteren
		messageText = messageText.replaceAll("\r", " ");
		messageText = messageText.replaceAll("\n", " ");
		messageText = messageText.replaceAll("-", " ");
		messageText = messageText.replaceAll("?", " ");
		messageText = messageText.replaceAll("!", " ");
		
		messageText = messageText.replace(/ {2,}/g,' ');
		
		var words = messageText.split(' ');
		
		//array_diff
		var filtered = words.filter(x => !stopwoord.includes(x));
		
		//mag 10 woorden
		filtered = filtered.slice(0,10);
		
		var newMessageText = filtered.join(' ').trim();
		
		if (newMessageText.length > 0) subject.value = newMessageText;
		  
	}
	
	idd_addEvent(document.getElementById('subject'), 'input', function() {
		message.removeEventListener('input', messageToSubject);
	});
		
	idd_addEvent(document.getElementById('message'), 'input', messageToSubject);

}


function service_openCloseBox() {
	
	const iddService = document.getElementById('iddService');
	if (iddService === null) return; //Alleen als gevonden is verder gaan.

	const iddServiceIcon = document.getElementById('iddService_icon');

	const serviceIframeURL = new URL(window.location);
	serviceIframeURL.searchParams.append('service', 1);

	const serviceIframe = document.createElement('iframe');
	serviceIframe.id    = 'serviceIframe';
	serviceIframe.src   = serviceIframeURL;
	
	let iddServiceBalloon = document.getElementById('iddService_balloon');

	// Als tekstballon bestaat: 
	if (iddServiceBalloon !== null) {
		// Iframe openen en tekstballon sluiten bij klik
		iddServiceBalloon.addEventListener('click', function() {
			service_openIframe();
			service_closeBalloon();
			iddServiceIcon.innerText = 'close';
		});

		// Icon veranderen in kruisje
		setTimeout(() => {
			iddServiceIcon.innerText = 'close';
			setTimeout(() => {
				// na ~10s weer uit beeld halen.
				if (iddServiceBalloon !== null) {
					service_closeBalloon();
				}
			}, 9500);
		}, 750);
	}
	
	// Openen/sluiten tekstballon en iframe bij klik
	iddServiceIcon.addEventListener('click', function() {
		// Sluiten van tekstballon of iframe
		if (this.innerText == 'close') {
			if (iddServiceBalloon !== null) {
				service_closeBalloon();
			} else {
				this.innerText = 'support_agent';
				serviceIframe.className = 'scaleOut'; //Animatie
				setTimeout(() => {
					serviceIframe.removeAttribute('class');
					serviceIframe.remove();
				}, 500);
			}
		} else { //Openen van iframe
			service_openIframe();
			this.innerText = 'close';
		}
	});

	function service_closeBalloon() {
		// Niet uitvoeren als niet bestaat
		if (!iddServiceBalloon) return;
		iddServiceIcon.innerText = 'support_agent';
		iddServiceBalloon.className = 'scaleOut'; //Animatie

		setTimeout(() => {
			iddServiceBalloon.removeAttribute('class');
			iddServiceBalloon.remove();
			iddServiceBalloon = undefined;
		}, 500);
	}
	
	// Pas na het laden de formaten meegeven.
	function service_openIframe() {
		// In beeld brengen.
		iddService.appendChild(serviceIframe);
		serviceIframe.onload = () => {
			const messageArea = serviceIframe.contentWindow.document.getElementById('message');
			
			messageArea.style.maxHeight = '150px';
			messageArea.style.overflowY = 'scroll';
			
			if ($(window).width() < 600) {
				serviceIframe.style.height = $(window).height() + "px";
				serviceIframe.style.width  = ($(window).width() - 10) + "px";
			} else {
				serviceIframe.style.height = serviceIframe.contentDocument.body.scrollHeight + "px";
				serviceIframe.style.width  = serviceIframe.contentDocument.body.scrollWidth + "px";
				// Als er tekst in de textarea is geplaatst refresh de hoogte van de servicelink iframe.
				if (messageArea.clientHeight < 150) {
					messageArea.onkeyup = () => {
						serviceIframe.style.height = serviceIframe.contentDocument.body.scrollHeight + "px";
						serviceIframe.style.width  = serviceIframe.contentDocument.body.scrollWidth + "px";
					}
				}
			}
			serviceIframe.className = 'scaleIn'; //Animatie
		}
	}
}


/**
 * Functie om een screenshot van een scherm of van een window te maken.
 *
 * @return {string} frame - de base64 van de screenshot die genomen is.
 */
async function _service_takeScreenshot() {
	// Omdat javascript single threaded is moest er een quasi sleep() functie zoals in PHP gemaakt worden.
	const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));
	// De pixelRatio kan de hoogtes en breedtes laten afwijken.
	// Zie mdn: https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio
	const innerHeight = parent.window.innerHeight * parent.window.devicePixelRatio;
	const innerWidth  = parent.window.innerWidth * parent.window.devicePixelRatio;
	const outerHeight = parent.window.outerHeight * parent.window.devicePixelRatio;
	const outerWidth  = parent.window.outerWidth * parent.window.devicePixelRatio;
	const screenX     = parent.window.screenX * parent.window.devicePixelRatio;
	const screenY     = parent.window.screenY * parent.window.devicePixelRatio;
	// Geeft een prompt aan de gebruiker om een scherm of window te kiezen.
	const captureStream = await navigator.mediaDevices.getDisplayMedia();
	// Wacht 150ms tot dat de popup window weg is.
	await sleep(150);
	
	const video = document.createElement('video');
	const output = await new Promise((resolve) => {
		video.onloadedmetadata = () => {
			video.play();
			video.pause(); // De video moet gepauzeerd worden omdat je bij drawImage een stilstaand plaatje moet hebben.
			const canvas = document.createElement('canvas');
			canvas.width  = video.videoWidth;
			canvas.height = video.videoHeight; // geef de canvas de hoogte en breedte van de stream.
			const context = canvas.getContext('2d');
			// Hoeveel de foto van boven gecropped moet worden.
			const browserHeadHeight = outerHeight - innerHeight;
			// Gekozen voor tab.
			if (video.videoHeight == innerHeight) {
				context.drawImage(video, // De image (wat hier een stilstaande video is)
				                  0, 0, // de dx en dy niet belangrijk wel nodig.
				                  innerWidth, innerHeight); // de dwidth en dheight is waar de file uitkomt.
			// Gekozen voor window.
			// Bij chrome kan er een afwijking zijn van een paar pixels daarom de marge van 10 pixels.
			} else if (outerHeight < video.videoHeight + 5 && outerHeight > video.videoHeight - 5) {
				context.drawImage(video, // De image (wat hier een stilstaande video is)
				                  0, browserHeadHeight, // de sx en sy is waar het gecropped word.
				                  innerWidth, innerHeight, // de swidth en sheight de grootte.
				                  0, 0, // de dx en dy niet belangrijk wel nodig.
				                  outerWidth, outerHeight); // de dwidth en dheight is waar de file uitkomt.
			// Gekozen voor fullscreen, valt namelijk niet binnen innerHeight of outerHeight.
			} else {
				context.drawImage(video, // De image (wat hier een stilstaande video is)
				                  screenX, screenY + browserHeadHeight, // de sx en sy is waar het gecropped word.
				                  innerWidth, innerHeight, // de swidth en sheight de grootte.
				                  0, 0, // de dx en dy niet belangrijk wel nodig.
				                  outerWidth, outerHeight); // de dwidth en dheight is waar de file uitkomt.
			}
			resolve(canvas);
		};
		video.srcObject = captureStream;
	})
	// stop de audio (kan corrupte data oorzaken)
	captureStream.getTracks().forEach(function (track) {
		track.stop();
	})
	// Maak base64 van de canvas.
	var frame = output.toDataURL('image/jpeg', 0.5);
	
	return frame;
}
